export const AccountHoldStatus = {
  AccountHoldStatusInvalid: 'AccountHoldStatusInvalid',
  AccountHoldStatusUpdateFailure: 'AccountHoldStatusUpdateFailure',
};

export const AccountInactiveReasons = {
  AccountMissingABL: 19,
};
